import setup from './moduleSetup';

export default {
    name: 'reducers',
    before: [],
    after: [],
    setup,
};
